import api from "../../../api.js";

export async function fetchPendingDeliveries({ branchcode } = {}) {
  try {
    const res = await api.get("/dispensary/delivery/pending", {
      params: {
        ...(branchcode ? { branchcode } : {}),
      },
    });
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchPendingDeliveries failed", e);
    return [];
  }
}

export async function fetchAssignedDeliveries({ branchcode } = {}) {
  try {
    const res = await api.get("/dispensary/delivery/assigned", {
      params: {
        ...(branchcode ? { branchcode } : {}),
      },
    });
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchAssignedDeliveries failed", e);
    return [];
  }
}

export async function fetchInTransitDeliveries({ branchcode } = {}) {
  try {
    const res = await api.get("/dispensary/delivery/in-transit", {
      params: {
        ...(branchcode ? { branchcode } : {}),
      },
    });
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchInTransitDeliveries failed", e);
    return [];
  }
}

export async function fetchCompletedDeliveries({ branchcode } = {}) {
  try {
    const res = await api.get("/dispensary/delivery/completed", {
      params: {
        ...(branchcode ? { branchcode } : {}),
      },
    });
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchCompletedDeliveries failed", e);
    return [];
  }
}

export async function fetchDeliveryDrivers() {
  try {
    const res = await api.get("/dispensary/delivery/drivers");
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchDeliveryDrivers failed", e);
    return [];
  }
}

export async function assignDeliveryDriver({ driverId, orderIds }) {
  try {
    console.log('🌐 [API] Calling assignDeliveryDriver:', { driverId, orderIds });
    
    const res = await api.post("/dispensary/delivery/assign-driver", {
      driverId,
      orderIds,
    });
    
    console.log('🌐 [API] Response received:', res.data);
    return res.data;
  } catch (e) {
    console.error('🌐 [API] assignDeliveryDriver failed:', e);
    console.error('🌐 [API] Error response:', e.response?.data);
    throw e;
  }
}

export async function assignDeliveryDriverWithAddress({ driverId, assignments }) {
  try {
    console.log('🌐 [API] Calling assignDeliveryDriverWithAddress:', { driverId, assignments });

    const res = await api.post("/dispensary/delivery/assign-driver", {
      driverId,
      assignments,
    });

    console.log('🌐 [API] Response received:', res.data);
    return res.data;
  } catch (e) {
    console.error('🌐 [API] assignDeliveryDriverWithAddress failed:', e);
    console.error('🌐 [API] Error response:', e.response?.data);
    throw e;
  }
}

export async function fetchDeliveryTracking({ orderId }) {
  try {
    const res = await api.get(`/dispensary/delivery/${orderId}/tracking`)
    return res.data?.data || null
  } catch (e) {
    console.warn("fetchDeliveryTracking failed", e)
    return null
  }
}
